import React from 'react';
import UnitCountOne from './child/UnitCountOne';
import MostUsedFeature from './child/MostUsedFeature';
import MostViewedPages from './child/MostViewedPages';
import LanguageWiseUser from './child/LanguageWiseUser';
import LanguageWiseUserTable from './child/LanguageWiseUserTable';
import MonthlyNewUsersChart from './child/MonthlyNewUser';
import DailyAIUsageChart from './child/AIUsage';
import UserByCountryChart from './child/UserByCountry';
import UserByVillageChart from './child/UserByVillage';
import TopCropsRanking from './child/TopCrops';
import TopVariants from './child/TopVariants';

const DashBoardLayerOne = ({ farmerData }) => {
  if (!farmerData) {
    return (
      <div className="alert alert-warning" role="alert">
        No data available for the selected date range.
      </div>
    );
  }

  return (
    <>
      <UnitCountOne
        totalUsers={farmerData.TotalFarmerCount}
        newSignUps={farmerData.FarmerSignedUpThisMonth}
        activeUsers={farmerData.ActiveUsers?.[0]?.TodaysActiveUserCount || 0}
        yesterdaysActiveUserCount={farmerData.ActiveUsers?.[0]?.YesterdaysActiveUserCount || 0}
        weatherAlerts={farmerData.WeatherAlert?.[0]?.TodaysCount || 0}
        yesterdaysWeatherCount={farmerData.WeatherAlert?.[0]?.YesterdaysCount || 0}
        cropAdvisoryAlerts={farmerData.CropAdvisoryAlert?.[0]?.TodaysCount || 0}
        yesterdaysAdvisoryCount={farmerData.CropAdvisoryAlert?.[0]?.YesterdaysCount || 0}
        totalFarmerCountVariation={farmerData.TotalFarmerCountVariation || 0}
      />

      <section className="row g-3 g-xl-4 mt-1">
        <MonthlyNewUsersChart monthWiseData={farmerData.MonthWiseFarmerSignUp} />
        <DailyAIUsageChart dailyAiUsage={farmerData.DailyAIUsage} />
        <UserByCountryChart countryData={farmerData.CountryWiseFarmerCount} />
        <UserByVillageChart villageData={farmerData.VillageWiseFarmerCount} />
        <TopCropsRanking
          topCrops={farmerData.TopCrop}
          topVariants={farmerData.TopVariants}
        />
        <TopVariants topVariants={farmerData.TopVariants} />

        <div className="col-12">
          <div className="row g-3">
            <MostUsedFeature mostViewedPages={farmerData.MostViewedPages} />
            <MostViewedPages mostViewedPages={farmerData.MostViewedPages} />
            <LanguageWiseUser languageData={farmerData.LanguageWiseFarmerCount} />
            <LanguageWiseUserTable languageData={farmerData.LanguageWiseFarmerCount} />
          </div>
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerOne;
